// services/socket.js
import { io } from "socket.io-client";

// Replace this with your actual backend socket server URL
const SOCKET_URL = io("https://8kl4c01f-9888.inc1.devtunnels.ms/api");

const socket = io(SOCKET_URL, {
    transports: ["websocket"],
    withCredentials: true,
  });
  
export default socket;